import { AemRecipeModelData } from "@/utils/types/aem";
import {
  Box,
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Text,
} from "@dxp-feed/ui";

const SaveReminder = ({
  isProgressModal,
  closeIsProgressModal,
  saveRecipesToFolder,
  aemRecipeModelData,
  saveAnywayDisable = false,
}: {
  isProgressModal: boolean;
  closeIsProgressModal: () => void;
  saveRecipesToFolder: () => void;
  aemRecipeModelData: AemRecipeModelData;
  saveAnywayDisable ?: boolean;
}) => {
  return (
    <Dialog
      isOpen={isProgressModal}
      onClose={closeIsProgressModal}
      className="max-w-[90%] md:max-w-[432px] p-0 "
    >
      <DialogHeader className="border-grey250 border-b-2 p-6 gap-4">
        <Text as="h2" className="font-bold max-w-[250px]">
          {aemRecipeModelData?.closeTitle}
          {/* If you close this window, your progress will be lost. */}
        </Text>
        <Button
          className="text-brandSecondary font-bold text-lg rounded-none"
          onClick={closeIsProgressModal}
          aria-label="Close modal"
          variant="icon"
          size="none"
        >
          <Text
            as="span"
            className="demo-icon icon-close text-brandBlack text-[14px] "
          ></Text>
        </Button>
      </DialogHeader>
      <DialogBody className="px-6 py-4 max-h-[325px] custom-scroll">
        <Text as="h2" className=" font-normal">
          {aemRecipeModelData?.closeMessage}
          {/* Make sure to save before exiting! */}
        </Text>
      </DialogBody>
      <DialogFooter className="border-grey250 border-t-2 p-6">
        <Box as="div" className="flex w-full justify-end gap-2">
          <Button
            variant="primary"
            className="border-0 bg-transparent text-[#003D2A] underline decoration-solid [&:hover]:border-0 [&:hover]:bg-transparent text-sm md:text-base "
            onClick={closeIsProgressModal}
            aria-label={aemRecipeModelData?.closeAnyway}
          >
            {aemRecipeModelData?.closeAnyway}
            {/* Close Anyway */}
          </Button>
          <Box as="div" className="flex ">
            <Button
              variant="primary"
              className="text-[14px] font-normal"
              disabled={saveAnywayDisable}
              onClick={saveRecipesToFolder}
              aria-label={aemRecipeModelData?.saveRecipeList}
            >
              {aemRecipeModelData?.saveRecipeList}
              {/* Save Recipe List */}
            </Button>
          </Box>
        </Box>
      </DialogFooter>
    </Dialog>
  );
};

export default SaveReminder;
